export const MODULE = "new/user-ui-interactions";

// Every element that remembers something per user gets a key here, so there is
// one list to read instead of magic strings spread across components.
//
// Keys are snake_case, exactly as they are stored in the database. The GET in
// user-ui-interactions.actions.js reads the response without the usual
// camelCase conversion so these keys arrive back untouched, and snake_casing an
// already-snake key on the way out does nothing. Match the backend's own key
// constants in pinpointsite/api/ui_interactions.py.
export const USER_INTERACTION_KEYS = {
  // Whether the "Send to contacts or customers by email" switch in the
  // create-document modal was last left on.
  INVOICE_EMAIL_ENABLED: "invoice_email_enabled",
  // When this Administrator saw or dismissed the Work Schedule first-time prompt (F01-11).
  WORK_SCHEDULE_PROMPT_SEEN: "work_schedule_prompt_seen",
};
